import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Drawer, Box } from "@mui/material";
import { IconMenu2, IconX } from "@tabler/icons-react";
import LogoBlack from "../../assets/Images/logoblack.webp";

const Header = () => {
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Virtual Office", path: "/virtual-office-chennai" },
    { name: "Services", path: "/services" },
    { name: "Partners", path: "/partners" },
    { name: "Blog", path: "/blog" },
  ];

  // 👇 Detect scroll position for shrink effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="fixed top-0 w-full flex justify-center z-50 bg-transparent transition-all duration-300">
      {/* Main Navbar Container */}
      <div
        className={`shadow-sm flex items-center justify-between rounded-2xl px-6 py-3 transition-all duration-500 ease-in-out`}
        style={{
          width: isScrolled ? "78%" : "90%",
          maxWidth: isScrolled ? "56rem" : "72rem",
          marginTop: isScrolled ? "2rem" : "2rem",
          transform: isScrolled ? "scale(0.97)" : "scale(1)",
          transition: "all 0.5s ease-in-out",
          background: "#ffffff30", // semi-transparent background
        backdropFilter: "blur(10px)", // blur effect
            border: "1px solid #ffffff85"
        
          
        }}
      >
        {/* Left: Logo */}
        <Link to="/" className="flex items-center gap-2 mr-20">
          <img
            src={LogoBlack}
            alt="Offis Bay Logo"
            className={`transition-all duration-500 ${
              isScrolled ? "h-7" : "h-8"
            } w-auto`}
          />
        </Link>

        {/* Center: Navigation */}
        <nav className="hidden md:flex items-center gap-10 text-gray-800 font-medium">
          {navLinks.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className={`relative transition-colors duration-300 ${
                location.pathname === link.path
                  ? "text-black after:scale-100"
                  : "text-gray-700 hover:text-black"
              } after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[2px] after:bg-black after:scale-0 after:transition-transform after:duration-300 hover:after:scale-100`}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Right: Contact Button */}
        <div className="hidden md:flex ml-20">
          <Link
            to="/contact"
            className="bg-[#966376] text-white px-6 py-3 rounded-xl font-[500] hover:bg-gray-900 transition-all"
          >
            Contact Us
          </Link>
        </div>

        {/* Mobile Menu Icon */}
        <button
          onClick={() => setShowMenu(true)}
          className="md:hidden text-gray-700"
        >
          <IconMenu2 size={26} />
        </button>
      </div>

      {/* Drawer for Mobile Menu */}
      <Drawer
        anchor="left"
        open={showMenu}
        onClose={() => setShowMenu(false)}
        PaperProps={{
          sx: { width: "75%", backgroundColor: "#fff", padding: "20px" },
        }}
      >
        <Box className="flex flex-col space-y-8 mt-10">
          <div className="flex justify-between items-center">
            <img src={LogoBlack} alt="Logo" className="h-8" />
            <button onClick={() => setShowMenu(false)}>
              <IconX size={24} />
            </button>
          </div>

          <nav className="flex flex-col space-y-5 text-gray-800 font-medium">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                onClick={() => setShowMenu(false)}
                className={`${
                  location.pathname === link.path
                    ? "text-black font-semibold"
                    : "text-gray-700 hover:text-black"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setShowMenu(false)}
              className="bg-black text-white text-center py-2 rounded-xl font-semibold hover:bg-gray-900 transition-all"
            >
              Contact Us
            </Link>
          </nav>
        </Box>
      </Drawer>
    </header>
  );
};

export default Header;
